// extracted by mini-css-extract-plugin
export default {"login":"Login-login-bMi","loginContent":"Login-loginContent-ZVg","loginTitle":"Login-loginTitle-LbQ","loginDesc":"Login-loginDesc-__L","loginAction":"Login-loginAction-Ed4"};